/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordData } from "../../records/types/RecordData";
export const Request = core.serialization.list(RecordData);
